'use client';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';
import {Typography} from '../primitives';

export interface HighlightCardProps {
  label: string;
  value: string;
}

const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  minHeight: 60,
  paddingInline: theme.spacing(2),
  borderRadius: theme.radii.xl,
  backgroundColor: theme.palette.colors.surface.neutral.subtle,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    minHeight: 0,
    padding: theme.spacing(3),
  },
}));

export function HighlightCard({label, value}: HighlightCardProps) {
  return (
    <Root>
      <Typography size="body-2" weight="regular" as="p" sx={{color: theme => theme.palette.colors.text.neutral.muted}}>
        {label}
      </Typography>
      <Typography size="body-1" weight="bold" family="primary" mobileSize="body-2" as="p">
        {value}
      </Typography>
    </Root>
  );
}

HighlightCard.displayName = 'HighlightCard';
